import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: any) => ({
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
    borderRadius: theme.spacing(0.5),
    backgroundColor: theme.palette.action.selected,
  },
  content: {
    flex: 1,
    minWidth: 0,
  },
  title: { color: theme.palette.text.primary },
  value: { overflowWrap: 'anywhere' },
  arrowUp: {
    fontSize: '24px',
    color: theme.palette.success.dark
  },
  arrowDown: {
    fontSize: '24px',
    color: theme.palette.info.dark
  },
  deleteButton: {
    padding: theme.spacing(0.5),
    '@media (hover: none) and (pointer: coarse)': {
      minWidth: theme.spacing(5.5),
      minHeight: theme.spacing(5.5),
    },
  },
  deleteIcon: { fontSize: 16 },
}));

type ListItemelementProps = {
  title: string,
  value: any,
  disabledButton?: boolean,
  onclickIcon: () => void,
  disabledDelete?: boolean
  relation?: boolean
  relationType?: 'parent' | 'subordinate'
}

const ListItemElement: FC<ListItemelementProps> = ({
  title,
  value,
  disabledButton,
  onclickIcon,
  disabledDelete,
  relation,
  relationType
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.row}>
      <Box className={classes.content}>
        <Typography variant="body2" className={classes.title}>{title}</Typography>
        <Typography variant="body2" className={classes.value}>{value}</Typography>
      </Box>
      {relation && (
        <FontAwesomeIcon
          aria-hidden
          icon={relationType === 'parent' ? 'arrow-up' : 'arrow-down'}
          className={relationType === 'parent' ? classes.arrowUp : classes.arrowDown}
        />
      )}
      {!disabledDelete && (
        <IconButton
          aria-label={`${t('common:delete')} ${value ?? title}`}
          className={classes.deleteButton}
          disabled={disabledButton}
          onClick={(e) => {
            e.stopPropagation();
            onclickIcon();
          }}
          size="large"
        >
          <FontAwesomeIcon icon="times-circle" className={classes.deleteIcon} />
        </IconButton>
      )}
    </div>
  );
};

export default ListItemElement;
